import axios from "axios";
import {Storage} from "@ionic/storage";
const storage = new Storage()

const state = {
    calendar: {
        weeks: []
    },
    meals: null,
    shopping_list: null,
    recipe: null,
    selectedWeek: 0,
    checked_shopping_list: null
}
const mutations = {
    SET_CALENDAR(state, data) {
        state.calendar = data
    },
    async SET_MEALS(state, data) {
        if(!data) {
            await storage.get('meals').then((val) => {
                data = val
            })
        }
        storage.set('meals', data)
        state.meals = data
    },
    async SET_SHOPPING_LIST(state, data) {
        if(!data) {
            await storage.get('shopping_list').then((val) => {
                data = val
            })
        }
        storage.set('shopping_list', data)
        state.shopping_list = data
    },
    SET_RECIPE(state, data) {
        state.recipe = data
    },
    SET_SELECTED_WEEK(state, data) {
        state.selectedWeek = data
    },
    UPDATE_CHECKED_SHOPPING_LIST(state, data) {
        state.checked_shopping_list = data
    }
}
const actions = {
    async loadNutritionChallenge ({rootState, commit, dispatch, rootGetters}) {
        axios.post(rootState.settings.baseUrl + 'mealplan/load-challenge', {},
            {
                provider: 'members',
                headers: {
                    'Authorization': 'Bearer ' + rootState.auth.token
                }
            }
        ).then(async response => {
            commit('global/SET_SYNCING', null, { root: true })
            dispatch('MealPlan/setMealTypes', response.data.meal_types, {root: true})
            dispatch('MealPlan/setChallenge', rootState.challenge.challenge, {root: true})
            //commit('SET_SELECTED_WEEK', rootGetters['challenge/currentWeek'])
        }).catch(error => {
            commit('global/SET_SYNCING', null, { root: true })
            console.error(error)
            throw error.response
        })
    },
    async loadNutritionData ({rootState, dispatch, commit, rootGetters, state}) {
        dispatch('Global/setLoading', 'Loading meal plan', {root: true})
        // check for challenge and load it
        if(state.selectedWeek < 1) {
            return dispatch('setWeek', rootGetters['challenge/currentWeek'])
        }
        if (!rootState.MealPlan.challenge) await dispatch('loadNutritionChallenge')
        // load mealplans
        axios.post(rootState.settings.baseUrl + 'mealplan/load', {week: state.selectedWeek},
            {
                provider: 'members',
                headers: {
                    'Authorization': 'Bearer ' + rootState.auth.token
                }
            })
            .then(function (response) {
                dispatch('Global/setLoading', null, {root: true})
                dispatch('MealPlan/setMealPlanItems', response.data, {root: true})
            })

    },
    loadShoppingList ({dispatch, rootState}, week) {
        // load shoppinglist
        dispatch('Global/setLoading', 'Loading shopping list', {root: true})
        axios.post(rootState.settings.baseUrl + 'shopping-list/load', {week: week},
            {
                provider: 'members',
                headers: {
                    'Authorization': 'Bearer ' + rootState.auth.token
                }
            })
            .then(async function (response) {
                let list = response.data
                var checkedShoppingList = []
                await storage.get('checked_shopping_list').then((val) => {
                    checkedShoppingList = val
                })
                if(!checkedShoppingList) checkedShoppingList = {}
                if(checkedShoppingList[week]) {
                    for (var catkey in list) {
                        let cat = list[catkey]
                        if(cat && checkedShoppingList[week][cat.id]) {
                            for (var itemkey in cat.items) {
                                let item = cat.items[itemkey]
                                if(item && checkedShoppingList[week][cat.id].indexOf(item.id) >= 0) {
                                    item.checked = true
                                }
                            }
                        }
                    }
                }

                dispatch('ShoppingList/setShoppingList', list, {root: true})
                dispatch('Global/setLoading', null, {root: true})
            })
    },
    loadRecipe ({commit, rootState}, slug) {
        commit('SET_RECIPE', null)
        //console.log('recipe', slug)
        commit('global/SET_SYNCING', 'Loading Recipe', {root: true})
        axios.post(rootState.settings.baseUrl + 'recipe', {
                slug: slug,
                stream: rootState.challenge.selected_stream
            },
            {
                provider: 'members',
                headers: {
                    'Authorization': 'Bearer ' + rootState.auth.token
                }
            }
        ).then(async response => {
            commit('global/SET_SYNCING', null, { root: true })
            //console.log('SUccess', response.data)
            commit('SET_RECIPE', response.data)
        }).catch(error => {
            // not know at club
            commit('global/SET_SYNCING', null, { root: true })
            commit('SET_RECIPE', 'not found')
            console.error(error)
            throw error.response
        })
    },
    async updateCheckedShoppingList ({commit, state, rootState}, week) {
        var checkedShoppingList = []
        await storage.get('checked_shopping_list').then((val) => {
            checkedShoppingList = val
        })
        if(!checkedShoppingList) checkedShoppingList = {}

        if(!checkedShoppingList[week]) checkedShoppingList[week] = {}

        for (var catkey in rootState.ShoppingList.shopping_list) {
            let cat = rootState.ShoppingList.shopping_list[catkey]
            if(cat) {
                for (var itemkey in cat.items) {
                    let item = cat.items[itemkey]
                    if(item && item.checked) {
                        if(!checkedShoppingList[week][catkey]) checkedShoppingList[week][catkey] = []
                        checkedShoppingList[week][catkey].push(item.id)
                    }
                }
            }
        }
        storage.set('checked_shopping_list', checkedShoppingList)
        //commit('UPDATE_CHECKED_SHOPPING_LIST', checked_shopping_list)
        //console.log(state.checked_shopping_list)
    },
    updateMealToken ({commit, rootState, dispatch}, data) {
        commit('global/SET_SYNCING', 'Updating Meal Token', {root: true})
        axios.post(rootState.settings.baseUrl + 'update-meal-token', {
                meal_plan_item_id: data.item.id,
                action: data.action
            },
            {
                provider: 'members',
                headers: {
                    'Authorization': 'Bearer ' + rootState.auth.token
                }
            }
        ).then(async response => {
            commit('global/SET_SYNCING', null, { root: true })
            if(response.data === 'success') dispatch('MealPlan/updateMealToken', {item: data.item, action: data.action}, {root: true})
            //dispatch('setNutritionData', response.data)
        }).catch(error => {
            // not know at club
            commit('global/SET_SYNCING', null, { root: true })
            dispatch('global/setNetworkError', null, {root: true})
            console.error(error)
            throw error.response
        })
    },
    setWeek ({commit, dispatch}, week) {
        commit('SET_SELECTED_WEEK', week)
        dispatch('MealPlan/setCurrentWeek', week, {root: true})
        dispatch('loadNutritionData')
    },
    loadRecipeSlug ({rootState, dispatch, commit}, value) {
        commit('global/SET_SYNCING', 'Loading recipe', {root: true})
        axios.post(rootState.settings.baseUrl + 'recipe/load-slug', {slug: value.slug, global_region_id: value.global_region_id},
            {
                provider: 'members',
                headers: {
                    'Authorization': 'Bearer ' + rootState.auth.token
                }
            })
            .then(function (response) {
                dispatch('Recipe/setRecipe', response.data, {root: true})
                dispatch('Recipe/getImage', null, {root: true})
                commit('global/SET_SYNCING', null, {root: true})
            })
    },
    setMemberStream ({rootState, dispatch, commit}, stream) {

        dispatch('Streams/setStream', stream, {root: true})

        window.axios.post(rootState.settings.baseUrl + 'stream/update', {stream: rootState.Streams.stream.id},
            {
                provider: 'members',
                headers: {
                    'Authorization': 'Bearer ' + rootState.auth.token
                }
            })
            .then(response => {
                dispatch('loadNutritionData')
            })
    }
}
export default {
  namespaced: true, state, mutations, actions
}
